<template>
	<div class="px-5">
		<app-table
			class="mt-5 is-not-selectable"
			name="apps"
			:columns="columns"
			:current-page="currentPage"
			:last-page="lastPage"
			:rows="rows"
			@on-search-event="onSearch"
			@on-page="changePage"
		>
			<template slot="rows" slot-scope="props">
				<td
					class="is-not-selectable"
					v-show="showRow(columns, 1)"
				>
					{{ props.row.id }}
				</td>
				<td v-show="showRow(columns, 2)">
					{{ props.row.name }}
				</td>
				<td>
					<app-tooltip-button
						color="green"
						icon="edit"
						text="Editar Módulo"
						@click-icon="edit(props.row)"
					/>
					<app-tooltip-button
						color="blue"
						icon="link"
						text="Recursos"
						@click-icon="openResources(props.row)"
					/>
					<app-tooltip-button
						color="red"
						icon="delete"
						text="Eliminar Módulo"
						@click-icon="openModalConfirmation(props.row)"
					/>
				</td>
			</template>
		</app-table>
		<app-confirmation-modal
			:loading="loading"
			:show-modal="modalConfirmation.value"
			@cancel="cancelModalConfirmation"
			@confirm="confirm()"
		/>
	</div>
</template>

<script>
import appConfirmationModal from '@/components/shared/app-confirmation-modal';
import appTooltipButton from '@/components/shared/app-tooltip-button';

function changePage(page) {
	this.$emit('change-page', page);
}

function confirm() {
	this.loading = true;
	this.$http
		.delete(`module/${this.modalConfirmation.selectedRow.id}`)
		.then(() => {
			this.showNotification('Registro eliminado correctamente');
			this.modalConfirmation.value = false;
			this.$emit('on-delete');
		})
		.finally(() => {
			this.loading = false;
		});
}

function edit({ id }) {
	this.goTo('page-module-edit', { params: { id } });
}

function onSearch(value) {
	this.$emit('on-search', value);
}

function openResources({ id, name }) {
	this.goTo('page-resource', { params: { moduleId: id, moduleName: name } });
}

function data() {
	return {
		loading: false,
	};
}

export default {
	name: 'module-list',
	components: {
		appConfirmationModal,
		appTooltipButton,
	},
	data,
	props: {
		columns: {
			type: Array,
			required: true,
		},
		currentPage: {
			type: Number,
			default: 0,
		},
		lastPage: {
			type: Number,
			default: 0,
		},
		rows: {
			type: Array,
			required: true,
		},
	},
	methods: {
		changePage,
		confirm,
		edit,
		onSearch,
		openResources,
	},
};
</script>



// WEBPACK FOOTER //
// src/components/modules/module-list.vue